import React from 'react';
import { Link } from 'react-router-dom';
import OptimizedImage from './OptimizedImage';
import { IMAGE_BLURS } from '../data/imageBlurs';

const ResearchSection: React.FC = () => {
    return (
        <section
            id="research"
            className="relative w-full min-h-screen flex flex-col justify-center bg-canvas text-text-primary py-24 md:py-32"
            aria-labelledby="research-heading"
        >
            {/* Split layout: Text left, Image right */}
            <div className="w-full px-6 md:px-24 lg:px-32 flex flex-col md:flex-row items-center gap-12 md:gap-16">
                {/* Text content - left side */}
                <div className="flex-1">
                    <h2
                        id="research-heading"
                        className="text-5xl md:text-7xl lg:text-8xl font-normal tracking-[-0.02em] text-text-primary mb-6 md:mb-8 leading-[1.1]"
                    >
                        Backed by science,<br />adapted to you
                    </h2>

                    <p className="text-lg md:text-xl text-text-primary leading-relaxed text-balance max-w-2xl">
                        Whether you need to perform on low energy or direct your high focus—Nura adapts to your exact state, helping you get where you need to be.
                    </p>

                    <Link
                        to="/research"
                        className="mt-6 md:mt-8 inline-block text-lg text-text-primary whitespace-nowrap bg-transparent border border-primary px-5 py-2 rounded-full hover:bg-text-primary hover:text-canvas transition-colors focus-visible:outline-2 focus-visible:outline-text-primary focus-visible:outline-offset-4 focus:outline-none"
                    >
                        Explore Research
                    </Link>
                </div>

                {/* Image Card - right side (same size as benefit cards) */}
                <div
                    className="relative w-[100vw] md:w-full md:max-w-[600px] -mx-6 md:mx-0 aspect-square flex-shrink-0 rounded-none md:rounded-2xl overflow-hidden isolate"
                    style={{ transform: 'translateZ(0)', WebkitMaskImage: '-webkit-radial-gradient(white, black)' }}
                >
                    <OptimizedImage
                        src="/images/science.webp"
                        mobileSrc="/images/science-mobile.webp"
                        blurSrc={IMAGE_BLURS.science}
                        alt="Person using Nura app"
                        containerClassName="w-full h-full"
                        className="absolute inset-0 w-full h-full object-cover object-top"
                    />
                </div>
            </div>
        </section>
    );
};

export default ResearchSection;
